import React, { useState, useEffect } from 'react';
import Enumerable from 'linq';
import { useMsal } from "@azure/msal-react";

//material mui components
import {
    Typography,
    TextField,
    Grid,
    Button,
    FormControl,
    FormControlLabel,
    Checkbox,
    Container,
    Card,
    InputLabel,
    OutlinedInput,
    InputAdornment,
    IconButton,
    FormHelperText
} from '@mui/material';

//icons
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import styleForm from '../Tool/Style';
import { loginUsuario, loginUsuarioAAD, auditoriaLogin } from '../../Actions/Usuarios/UsuarioAction';
import { AutorizacionUsuario } from '../../Actions/Usuarios/AutorizacionAction';
import { validarLicenciaAppExterna } from '../../Actions/ClassStore/AppExternasAction';
import { withRouter } from 'react-router-dom';
import { useStateValue } from '../../Contexto/store';
import Config from '../../Configuracion/Configuraciones';
import RutasComponente from '../../Configuracion/RutaComponentes';
import DiccionarioEtiquetas from '../../Configuracion/Idiomas/Etiquetas_Diccionario';
import AsignaIdomaEtiquetas, { obtenerMensajeIdiomaCodigo, enlistaArrayCodigosMensajesIdiomas } from '../../Actions/Generales/IdiomasAction';
import { ListarArchivosServidor, BajarArchivosServidor } from '../../Actions/Generales/ManejoArchivosAction';
import { obtenerConfiguracionHoraFecha, obtenerImagenReducida } from '../../Actions/Companias/CompaniaAction';
import { ValidarTipoLoginPortal } from '../../Actions/Login/LoginAction';
import LoginTemp from '../../Activos/Imagenes/Modulos/LoginTemp.svg';
import LogoClassLimitless from '../../Activos/Imagenes/LogoClassLimitless.svg';
import { CarpetasAdjuntos } from '../../Configuracion/Llaves/CarpetasAdjuntos';

import BackGround1024 from '../../Activos/Imagenes/LoginScreen/banner-administrativos-1024X576.jpg';
import BackGround1366 from '../../Activos/Imagenes/LoginScreen/banner-administrativos-1366X768.jpg';
import BackGround1440 from '../../Activos/Imagenes/LoginScreen/banner-administrativos-1440X810.jpg';
import BackGround1536 from '../../Activos/Imagenes/LoginScreen/banner-administrativos-1536X864.jpg';
import BackGround1920 from '../../Activos/Imagenes/LoginScreen/banner-administrativos-1920X1080.jpg';
import LogoOfficeMS from '../../Activos/Imagenes/LogosLogin/MSLogo.svg';

import { MostrarMensaje } from '../../Utilidades/ManejoMensajes';
import { getWindowDimensions } from '../../Utilidades/DimensionesPantalla';

import { obtenerUbicacionUsuario } from '../../Utilidades/Localizacion';


import { LlavesAuthConfig } from "../../Configuracion/Llaves/RepositorioConfig";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const Login = (props) => {

    const { instance, accounts } = useMsal();    

    const ObjTiposImg = [
        {
            Tipo: ".apng",
            Base: "image/apng"
        },
        {
            Tipo: ".avif",
            Base: "image/avif"
        },
        {
            Tipo: ".gif",
            Base: "image/gif"
        },
        {
            Tipo: ".jpg",
            Base: "image/jpeg"
        },
        {
            Tipo: ".jpeg",
            Base: "image/jpeg"
        },
        {
            Tipo: ".jpe",
            Base: "image/jpeg"
        },
        {
            Tipo: ".jif",
            Base: "image/jpeg"
        },
        {
            Tipo: ".jfif",
            Base: "image/jpeg"
        },
        {
            Tipo: ".png",
            Base: "image/png"
        },
        {
            Tipo: ".svg",
            Base: "image/svg+xml"
        },
        {
            Tipo: ".webp",
            Base: "image/webp"
        },
    ];

    //console.log(accounts);

    const dimensionPantalla = getWindowDimensions();
    const BackGround = ((dimensionPantalla.width === null) ? BackGround1920 :
        ((dimensionPantalla.width <= 1024) ? BackGround1024 :
            (((dimensionPantalla.width <= 1366) ? BackGround1366 :
                (((dimensionPantalla.width <= 1440) ? BackGround1440 :
                    ((dimensionPantalla.width <= 1536) ? BackGround1536 : BackGround1920)))))));

    //console.log(dimensionPantalla, BackGround);

    //se accede al storage para ver la variable de sesion de usuario
    // contexto de variables globales con el Context Api 
    const [{ sesionUsuario, autorizacion, etiquetasIdioma }, dispatch] = useStateValue();

    // Se declara la variable de estado que representa al idioma para las etiquetas del componente
    const [remenber, setRemenber] = useState(false);
    const [tipoLogin, setTipoLogin] = useState("");

    // Se declara la variable de estado que representa al idioma para las etiquetas del componente
    const [etiquetas, setEtiquetas] = useState({
        EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
        CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
    });

    const [ImagenMostrar, setImagenMostrar] = useState('');

    const [errorEmail, setErrorEmail] = useState({
        error: false,
        errorText: ''
    });
    const [errorPassword, setErrorPassword] = useState({
        error: false,
        errorText: ''
    });    

    useEffect(() => {
        dispatch({ type: "LOAD_COMP", texto: etiquetas.EtiquetasComponente.CargandoModal.Et_Procesando });
        InicializarVentanaLogin();
        
    }, []);

    const InicializarVentanaLogin = async () => {
        await obtenerImagenLoginInicio();
        await validarTipoLogin();
    };

    const obtenerImagenLoginInicio = async () => {
        await obtenerImagen();
    };

    const buscarTipoArchivo = (Extension) => {
        const objTipo = ObjTiposImg.find(obj => obj.Tipo === Extension);
     
        if (objTipo)
            return objTipo.Base;
        else
            return '';
    };

    // se realiza el lamado a la funcion del action que va a pedir informaciocn a Api 
    const obtenerImagen = async () => {
        const objetoListar = {
            FolderName: CarpetasAdjuntos.ImagenLogin,
            ObjectId: '00000000-0000-0000-0000-000000000000',
            Top: 0,
            CompanyId: '00000000-0000-0000-0000-000000000000',
            UserId: '00000000-0000-0000-0000-000000000000'
        };

        let nombreTemp = "";
        let tipoExtension = "";

        await ListarArchivosServidor(objetoListar).then(response => {
            if (response.status === 200) //si la respuesta fue existosa 
            {
                // se asigna al objeto de variable de estado local la respuesta 
                if (response.data.length > 0) {
                    tipoExtension = buscarTipoArchivo(response.data[0].fileType);  
                    nombreTemp = response.data[0].fileName                    
                }
            }            
        });

        let tempDataImg = undefined;

        try {
            const tempData = localStorage.getItem("imagenLoginAdmCL");
            if (tempData)
                tempDataImg = JSON.parse(tempData);
        } catch (e) {
            tempDataImg = undefined;
        }
        //console.log("tempDataImg", tempDataImg);

        if (tempDataImg !== undefined) {
            if (nombreTemp !== "" && (tempDataImg.Nombre !== nombreTemp || tempDataImg.Tipo !== tipoExtension)) {
                await BajarArchivo(nombreTemp, tipoExtension);
            } else if (nombreTemp !== "") {
                setImagenMostrar(tempDataImg.Data);
            } else {
                setImagenMostrar('');
            }
        }
        else if (nombreTemp !== "") {
            await BajarArchivo(nombreTemp, tipoExtension);
        } else {
            setImagenMostrar('');
        }
    };

    const BajarArchivo = async (nombreArchivo, tipoExtension) => {
        const objetoBajar = {
            FileName: nombreArchivo,
            FolderName: CarpetasAdjuntos.ImagenLogin,
            ObjectId: '00000000-0000-0000-0000-000000000000',
            CompanyId: '00000000-0000-0000-0000-000000000000',
            UserId: '00000000-0000-0000-0000-000000000000'
        };

        const responseBajarAdjunto = await BajarArchivosServidor(objetoBajar);
        if (responseBajarAdjunto.status === 200) //si la respuesta fue existosa
        {
            const imgTemp = "data:" + tipoExtension + ";base64," + responseBajarAdjunto.data;
            const tempDataImg = {
                Nombre: nombreArchivo,
                Tipo: tipoExtension,
                Data: imgTemp
            };
            window.localStorage.setItem("imagenLoginAdmCL", JSON.stringify(tempDataImg));
            setImagenMostrar(imgTemp);
        }

    };

    const validarTipoLogin = async () => {      
        await ValidarTipoLoginPortal("A").then(response => {
            if (response.status === 200) {
                setTipoLogin(response.data.tipoLogin);
                
            }
            else { //si la respuesta NO fue existosa
                setTipoLogin("C");
            }
        });
    };

    useEffect(() => {
        if (tipoLogin === "C") {
            let rem = localStorage.getItem("remember");
            if (rem == null)
                rem = false;
            setRemenber(rem);
            if (rem) {
                const u = localStorage.getItem("User");
                if (u !== null) {
                    const up = {
                        Email: u,
                        Password: ''
                    }
                    AsignaUsuario(up);
                }
            }
        }
        if (tipoLogin !== "")
            dispatch({ type: "CLOSE_LOAD_COMP" });
    }, [tipoLogin]);

    useEffect(() => {
        // se llama al dispatch para que como tal se actualice el reducer
        setEtiquetas({
            EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
            CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
        });

    }, [etiquetasIdioma]);

    useEffect(() => {
        if (sesionUsuario?.autenticado) {
            let autorizaNavegacionUsuario = autorizacion ? autorizacion : RutasComponente; // se extrae la navegacion del reducer  
            // se redirecciona al componente de login posterior a que se ha realizado el logueo
            props.history.push(Config.rutaPublicacion + autorizaNavegacionUsuario.RutaHome.path);
        }
    }, [sesionUsuario]);

    // Se declara la variable de la memoria de js que representa el estamo manejado por el hook 
    const [usuario, AsignaUsuario] = useState({
        showPassword: false,
        Email: '',
        Password: ''
    });

    const handleClickShowPassword = () => {
        AsignaUsuario({
            ...usuario,
            showPassword: !usuario.showPassword,
        });
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    //const ingresarValoresMemoria = (prop) => (event) => {
    //    AsignaUsuario({ ...usuario, [prop]: event.target.value });
    //};

    //registra los cambios de valores en el form por medio de useState y del objeto de la momoria de js   
    const ingresarValoresMemoria = (e) => {
        const { name, value } = e.target; // representa la extraccion de valor del objeto que se esta sacando 
        AsignaUsuario(
            anterior => (
                {
                    ...anterior,
                    [name]: value
                }
            )
        );  // se llama a la funcion de asignacion de useEstate para asignar el valor que se toma de e 
        // hace el paremo por el nombre del objeto en el form , como un mapeo 
        // usa la funcion flecha para retornar una funcion 
    };

    const obtieneFormatosFechaHora = async (companiaId) => {
        const responseFormatos = await obtenerConfiguracionHoraFecha(companiaId);

        if (responseFormatos.status === 200) //si la respuesta fue existosa
        {
            window.localStorage.setItem("formatFecha_ClassLimitless", responseFormatos.data.datesFormat);
            window.localStorage.setItem("formatHora_ClassLimitless", responseFormatos.data.hoursFormat);
        } else {
            window.localStorage.setItem("formatFecha_ClassLimitless", "dd/MM/yyyy");
            window.localStorage.setItem("formatFecha_ClassLimitless", 12);
        }
    };

    const obtieneLogoCompaniaReducida = async (companiaId) => {

        const peticionImagen = {
            CompanyId: companiaId
        };
        const responseImagen = await obtenerImagenReducida(peticionImagen);

        if (responseImagen.status === 200) //si la respuesta fue existosa
        {
            let imgCompania = responseImagen.data?.contentBase64;
            if (imgCompania === undefined || imgCompania === null)
                imgCompania = "";
            window.localStorage.setItem("logoCompania_ClassLimitless", imgCompania);

        } else {
            window.localStorage.setItem("logoCompania_ClassLimitless", "");            
        }
    };

    const generaAuditoriaLogin = async (usrId, mail, exitoso, errores) => {

        const locacionUsr = await obtenerUbicacionUsuario();

        const usuarioLog = {
            UserId: usrId,
            UserAccount: mail,
            Successful: exitoso,
            Error: errores,
            CountryCode: locacionUsr.countryCode,
            CountryName: locacionUsr.countryName,
            City: locacionUsr.city,
            Postal: locacionUsr.postal,
            State: locacionUsr.state,
            Latitude: locacionUsr.latitude.toString(),
            Longitude: locacionUsr.longitude.toString(),
            IPv4: locacionUsr.ipv4
        };

        await auditoriaLogin(usuarioLog).then(response => {
            if (response.status !== 200) { //si la respuesta NO fue existosa
                if (response.data.errors) {
                    const arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
                    MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
                } else {
                    MostrarMensaje(dispatch, 'error', [response.statusText]);
                }
            }
        });
    };

    const validarLicenciaAppExternaKrud = async () => {

        await validarLicenciaAppExterna("KRUD").then(response => {
            if (response.status === 200) //si la respuesta fue existosa 
            {
                try {
                    window.localStorage.setItem("licenceKrudAdm", JSON.stringify(response.data));
                } catch (ee) {
                    const tempObj = {
                        activeLicense: false,
                        licenseCode: ''
                    };

                    window.localStorage.setItem("licenceKrudAdm", JSON.stringify(tempObj));
                }
            }
            else {
                const tempObj = {
                    activeLicense: false,
                    licenseCode: ''
                };

                window.localStorage.setItem("licenceKrudAdm", JSON.stringify(tempObj));
            }

            dispatch({ type: "CLOSE_LOAD_COMP" });
        });

    };


    const aplicaLoginClass = async (e) => {
        e.preventDefault();
        
        dispatch({ type: "LOAD_COMP", texto: etiquetas.EtiquetasComponente.CargandoModal.Et_Procesando });
        // se consume el action que actualiza al usuario
        await loginUsuario(usuario, dispatch).then(response => {

            // En caso de ser nulo se dejan las rutas del archivo de rutas inicial que esta todo como denegado
            // caso contrario lo toma del reducer de rutas 
            if (response.status === 200) //si la respuesta fue existosa 
            {
                let idiomaLocalStorage = etiquetas.CodigoIdioma;

                if (response.data.defaultLanguage !== idiomaLocalStorage) {
                    window.localStorage.setItem("etiqueta_idioma", response.data.defaultLanguage);
                    idiomaLocalStorage = response.data.defaultLanguage;
                }

                if (remenber === true) {
                    localStorage.setItem("User", usuario.Email);
                }

                generaAuditoriaLogin(response.data.userId, usuario.Email, true, '');

                obtieneFormatosFechaHora(response.data.companyId);
                obtieneLogoCompaniaReducida(response.data.companyId);
                //Se llama al action para que realice la autorizacion 
                //Modulo 
                //Username
                //Idioma
                //dispatch
                AutorizacionUsuario(response.data.companyId, "11111111-1111-1111-1111-111111111111", response.data.userId, idiomaLocalStorage, dispatch);
                // Se extraen las etiquetas en el idioma seleccionado para el usuario
                AsignaIdomaEtiquetas(idiomaLocalStorage, dispatch);

                validarLicenciaAppExternaKrud();
  
            }
            else {
                dispatch({ type: "CLOSE_LOAD_COMP" });

                let Errores = ''

                if (response.data.errors) {

                    let arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
                    Errores = arrayErrores.toString();

                    if (Enumerable.from(response.data.errors).any(x => x.value[0] === 'ErrorEmailVacio')) {
                        setErrorEmail({ error: true, errorText: obtenerMensajeIdiomaCodigo(etiquetasIdioma.CodigoIdioma, 'ErrorEmailVacio').mensaje });
                        const resultSinEmail = arrayRemove(arrayErrores, 'ErrorEmailVacio');
                        arrayErrores = resultSinEmail;
                    } else {
                        setErrorEmail({ error: false, errorText: '' });
                    }

                    if (Enumerable.from(response.data.errors).any(x => x.value[0] === 'ErrorContrasenaVacio')) {
                        setErrorPassword({ error: true, errorText: obtenerMensajeIdiomaCodigo(etiquetasIdioma.CodigoIdioma, 'ErrorContrasenaVacio').mensaje });
                        const resultSinPass = arrayRemove(arrayErrores, 'ErrorContrasenaVacio');
                        arrayErrores = resultSinPass;
                    } else {
                        setErrorPassword({ error: false, errorText: '' });
                    }

                    if (arrayErrores.length > 0) {
                        MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
                    }

                } else {
                    MostrarMensaje(dispatch, 'error', [response.statusText]);
                    try {
                        Errores = response.statusText.substring(0, 499);
                    } catch (e) { }
                }

                generaAuditoriaLogin('', usuario.Email, false, Errores);

            }
        });
    };

    const aplicaLoginAD = async (usuarioAD) => {

        dispatch({ type: "LOAD_COMP", texto: etiquetas.EtiquetasComponente.CargandoModal.Et_Procesando });
        // se consume el action que actualiza al usuario
        await loginUsuarioAAD(usuarioAD, dispatch).then(response => {

            // En caso de ser nulo se dejan las rutas del archivo de rutas inicial que esta todo como denegado
            // caso contrario lo toma del reducer de rutas 
            if (response.status === 200) //si la respuesta fue existosa 
            {
                let idiomaLocalStorage = etiquetas.CodigoIdioma;

                if (response.data.defaultLanguage !== idiomaLocalStorage) {
                    window.localStorage.setItem("etiqueta_idioma", response.data.defaultLanguage);
                    idiomaLocalStorage = response.data.defaultLanguage;
                }

                if (remenber === true) {
                    localStorage.setItem("User", usuarioAD.Email);
                }

                generaAuditoriaLogin(response.data.userId, usuarioAD.Email, true, '');

                obtieneFormatosFechaHora(response.data.companyId);
                obtieneLogoCompaniaReducida(response.data.companyId);
                //Se llama al action para que realice la autorizacion 
                //Modulo 
                //Username
                //Idioma
                //dispatch
                AutorizacionUsuario(response.data.companyId, "11111111-1111-1111-1111-111111111111", response.data.userId, idiomaLocalStorage, dispatch);
                // Se extraen las etiquetas en el idioma seleccionado para el usuario
                AsignaIdomaEtiquetas(idiomaLocalStorage, dispatch);

                validarLicenciaAppExternaKrud();

            }
            else {
                dispatch({ type: "CLOSE_LOAD_COMP" });

                let Errores = ''

                if (response.data.errors) {

                    let arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
                    Errores = arrayErrores.toString();

                    if (Enumerable.from(response.data.errors).any(x => x.value[0] === 'ErrorEmailVacio')) {
                        setErrorEmail({ error: true, errorText: obtenerMensajeIdiomaCodigo(etiquetasIdioma.CodigoIdioma, 'ErrorEmailVacio').mensaje });
                        const resultSinEmail = arrayRemove(arrayErrores, 'ErrorEmailVacio');
                        arrayErrores = resultSinEmail;
                    } else {
                        setErrorEmail({ error: false, errorText: '' });
                    }

                    if (Enumerable.from(response.data.errors).any(x => x.value[0] === 'ErrorContrasenaVacio')) {
                        setErrorPassword({ error: true, errorText: obtenerMensajeIdiomaCodigo(etiquetasIdioma.CodigoIdioma, 'ErrorContrasenaVacio').mensaje });
                        const resultSinPass = arrayRemove(arrayErrores, 'ErrorContrasenaVacio');
                        arrayErrores = resultSinPass;
                    } else {
                        setErrorPassword({ error: false, errorText: '' });
                    }

                    if (arrayErrores.length > 0) {
                        MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
                    }

                } else {
                    MostrarMensaje(dispatch, 'error', [response.statusText]);
                    try {
                        Errores = response.statusText.substring(0, 499);
                    } catch (e) { }
                }

                generaAuditoriaLogin('', usuarioAD.Email, false, Errores);

            }
        });
    };

    const handleChange = () => {
        if (!remenber) {
            localStorage.setItem("remember", !remenber);
        } else {
            localStorage.removeItem("remember");
            localStorage.removeItem("User");
        }
        setRemenber(!remenber);
    };

    const onFocus = event => {
        if (!remenber) {
            if (event.target.autocomplete) {
                event.target.autocomplete = "whatever";
            }
        }
    };

    function arrayRemove(arr, value) {
        return arr.filter(function (ele) {
            return ele != value;
        });
    };

    const sectionStyle = {
        height: "100%",
        width: '100%',
        display: 'flex',
        backgroundImage:
            `url(${BackGround})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover"
    };

    const handleLoginExternal = () => {
        if (tipoLogin === "O") {//Office365 Microsoft
            const loginRequest = LlavesAuthConfig.loginRequest;
            const loginType = LlavesAuthConfig?.view?.loginType;
            if (loginType === "redirect") {
                redirectLoginOffice365(loginRequest);
            }
            else if (loginType === "popup") {
                popUpLoginOffice365(loginRequest);
            }
            else {
                redirectLoginOffice365(loginRequest);
            }
        }
    }

    const redirectLoginOffice365 = async (loginRequest) => {
        
        const respuestaLogin = await instance.loginRedirect(loginRequest);

        const usuarioAD = {
            Email: respuestaLogin?.account?.username
        };

        aplicaLoginAD(usuarioAD);
      
    };

    const popUpLoginOffice365 = async (loginRequest) => {
       
        const respuestaLogin = await instance.loginPopup(loginRequest);

        const usuarioAD = {
            Email: respuestaLogin?.account?.username,
            AppExterna: true
        };

        aplicaLoginAD(usuarioAD);

    };

    return (
        <div style={sectionStyle}>
            <Container maxWidth="sm" justify="center" style={{ margin: "3rem 5rem" }} >
                <Card style={{ padding: '3rem', borderRadius: '1%', backgroundColor: "#F6F8FB" }}>
                    <div style={{
                        marginTop: 8, display: 'flex', flexDirection: "column", 
                        alignItems: "center", backgroundColor: "#F6F8FB", position: 'relative'
                    }}>
                        <img src={(ImagenMostrar === '' ? LogoClassLimitless : ImagenMostrar)} alt={"Imagen de universidad"}
                            style={{ margin: "0px", maxWidth: "200px", maxHeight: "100px", minWidth: "200px", minHeight: "100px" }} />
                        <Typography style={{ fontSize: 36, fontWeight: 800, color: "black", paddingTop: 25 }}>
                            {etiquetas.EtiquetasComponente.LoginScreen.Et_TituloPrincipal}
                        </Typography>                        
                    </div>
                    <form style={styleForm.form}>
                        <Grid container style={{ backgroundColor: 'transparent' }}>
                            <Grid item xs={12} style={{ padding: '8px 12px' }} >
                                <TextField
                                    name="Email"
                                    value={usuario.Email}
                                    variant="outlined"
                                    fullWidth
                                    label={etiquetas.EtiquetasComponente.LoginScreen.Et_txtUsuario}
                                    onChange={ingresarValoresMemoria}
                                    autoComplete={remenber ? "on" : "off"}
                                    onFocus={onFocus}
                                    error={errorEmail.error}
                                    helperText={errorEmail.errorText}
                                    inputProps={{
                                        maxLength: 256
                                    }}>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} style={{ padding: '8px 12px' }} >
                                
                                    <FormControl variant="outlined" fullWidth>
                                        <InputLabel htmlFor="outlined-adornment-password">{etiquetas.EtiquetasComponente.LoginScreen.Et_txtPassword}</InputLabel>
                                        <OutlinedInput
                                            autoComplete={remenber ? "on" : "off"}
                                            onFocus={onFocus}
                                            name="Password"
                                            id="outlined-adornment-password"
                                            type={usuario.showPassword ? 'text' : 'password'}
                                            value={usuario.Password}
                                            onChange={ingresarValoresMemoria}
                                            error={errorPassword.error}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={handleClickShowPassword}
                                                        onMouseDown={handleMouseDownPassword}
                                                        edge="end"
                                                    >
                                                        {usuario.showPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                            label={etiquetas.EtiquetasComponente.LoginScreen.Et_txtPassword}
                                            inputProps={{
                                                maxLength: 20
                                            }}
                                        />
                                        <FormHelperText error={errorPassword.error}>{errorPassword.errorText}</FormHelperText>
                                    </FormControl>
                                    
                                  {/*  <TextField
                                        name="Password"
                                        disabled={tipoLogin !== "C"}
                                        type="password"
                                        value={usuario.Password}
                                        variant="outlined"
                                        fullWidth
                                        label={etiquetas.EtiquetasComponente.LoginScreen.Et_txtPassword}
                                        onChange={ingresarValoresMemoria}
                                        autoComplete={remenber ? "on" : "off"}
                                        onFocus={onFocus}
                                        error={errorPassword.error}
                                        helperText={errorPassword.errorText}
                                        inputProps={{
                                            maxLength: 20
                                        }}>
                                    </TextField>*/}
                                
                            </Grid>
                            <Grid item xs={12} style={{ marginTop: "-20px", padding: '8px 12px' }} >
                                <FormControlLabel variant='body1'
                                    control={
                                        <Checkbox name="RemenberMe" fullWidth size="medium" checked={remenber} onChange={handleChange} />
                                    }
                                    label={etiquetas.EtiquetasComponente.LoginScreen.Et_txtRemenber}
                                />
                            </Grid>
                            <Grid item xs={12} style={{ padding: '8px 12px' }} >
                               
                                <Button 
                                    type="Submit" 
                                    fullWidth 
                                    variant="contained" 
                                    color="primary" 
                                    style={styleForm.botonPrimario /*tipoLogin === "C" ? : { backgroundColor: "#c1c8dd", color: "#FFF" }*/}
                                    size="large" 
                                    onClick={aplicaLoginClass}>
                                    {etiquetas.EtiquetasComponente.LoginScreen.Et_BotonAccionAcceso}
                                </Button>
                                
                            </Grid>
                            <Grid item xs={12} style={{ padding: '8px 12px' }} >
                                
                                <a href={Config.rutaPublicacion + "/auth/recovery"}>
                                    <Typography variant="body2">
                                        {etiquetas.EtiquetasComponente.LoginScreen.Et_RecuperarCont}
                                    </Typography>
                                </a>
                                {/*:
                                <Typography variant="body2" style={{ textDecoration: "underline", color: "rgba(0, 0, 0, 0.38)"}} >
                                    {etiquetas.EtiquetasComponente.LoginScreen.Et_RecuperarCont}
                                </Typography> */}
                                
                            </Grid>
                        </Grid>
                    </form> 
                    {tipoLogin === "O" ?
                        <Grid container style={{ backgroundColor: 'transparent', marginTop: '10px', marginBottom: '10px' }}>
                            <Grid item xs={12} style={{ padding: '8px 12px', textAlign: 'center' }} >
                                <div style={{
                                    width: '100%', textAlign: 'center', marginBottom: '10px'
                                }} >
                                    <table border="0" cellpadding="0" style={{ width: '100%', transform: 'translateX(-50%)', marginLeft: '50%', borderSpacing: '0px' }} >
                                        <tr>
                                            <td width="45%">
                                                <div style={{ width: '100%', height: '1px', borderTop: '1px solid rgba(0, 0, 0, 0.6)'}}>
                                                </div>
                                            </td>
                                            <td width="10%">
                                                <div style={{ height: '3px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
                                                    <span style={{ fontSize: '16px', fontWeight: '400', lineHeight: '24px', color: 'rgba(0, 0, 0, 0.6)' }} >
                                                        {"O"}
                                                    </span>
                                                </div>
                                            </td>
                                            <td width="45%">
                                                <div style={{ width: '100%', height: '1px', borderTop: '1px solid rgba(0, 0, 0, 0.6)' }}>
                                                </div>
                                            </td>
                                        </tr>
                                       
                                    </table>
                                </div>

                            </Grid>
                            <Grid item xs={12} style={{ padding: '8px 12px', textAlign: 'center' }} >
                                <div style={{
                                    width: '100%', height: '38px', textAlign: 'center',
                                    cursor: 'pointer', border: '1.5px solid rgba(0, 0, 0, 0.6)', borderRadius: '5px',
                                    boxShadow: "0px 0px 10px -6px rgba(0,0,0,0.6)",
                                    //transform: 'translateX(-50%)', marginLeft: '50%'
                                }} onClick={() => handleLoginExternal()} >
                                    <table border="0" cellpadding="0" style={{ height: '38px', transform: 'translateX(-50%)', marginLeft: '50%', borderSpacing: '0px' }} >
                                    
                                        <tr>
                                            <td>
                                                <div style={{ width: '26px', height: 'auto', paddingTop: '4px', marginRight: '10px' }}>
                                                    <img src={LogoOfficeMS} alt={"..."} style={{ width: '26px', height: '26px' }} />
                                                </div>
                                            </td>
                                            <td>
                                                <div style={{ height: '38px', width: 'max-content', display: 'flex', alignItems: 'center', justifyContent: 'left' }} >
                                                    <span style={{ fontSize: '16px', fontWeight: '400', lineHeight: '24px', color: 'rgba(0, 0, 0, 0.6)' }} >
                                                        {etiquetas.EtiquetasComponente.LoginScreen.Et_txtLoginExterno + "Microsoft"}
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                       
                                    </table>
                                </div>

                            </Grid>
                        </Grid>
                        :
                        null
                    }
                    <Grid container style={{ backgroundColor: 'transparent' }}>
                        <Grid item xs={12} style={{ padding: '8px 12px' }} >
                            <div style={{ display: 'flex', flexDirection: "column", alignItems: "center", backgroundColor: "#F6F8FB" }}>
                                <img src={LoginTemp} alt={"Imagen de Registro"} style={{ marginTop: "15px" }} />
                                <Typography style={{ marginTop: 10, fontSize: 16, fontWeight: 400, color: "#9099A9", textAlign: 'center', maxWidth: 255 }}>
                                    {etiquetas.EtiquetasComponente.LoginScreen.Et_Copyright}
                                </Typography>
                            </div>
                        </Grid>
                    </Grid>
                </Card>
            </Container>
            <div style={{ width: '100%', margin: "3rem 0rem", display: "none" }}>

            </div>
        </div >
    );
};

export default withRouter(Login);